<template>
  <div>
    <!-- 查询条件 -->
    <b-row ref="queryFormWrapper" class="p-2">
      <b-col cols="10">
        <b-form inline>
          <b-form-select
            style="min-width:200px;"
            class="m-1"
            :options="orgList"
            v-model="queryParam.criteria.orgId"
            v-if="showOrg"
            placeholder="请选择机构"
          ></b-form-select>
          <b-form-select
            style="min-width:100px;"
            class="m-1"
            :options="fileSourceList"
            v-model="queryParam.criteria.fileSource"
          ></b-form-select>
          <b-form-select
            style="min-width:100px;"
            class="m-1"
            :options="invCheckResultList"
            v-model="queryParam.criteria.invCheckResult"
          ></b-form-select>

          <b-form-input
            style="min-width:150px;"
            class="m-1"
            placeholder="提交人或发票号"
            v-model="queryParam.criteria.submitter"
          ></b-form-input>

          <date-range-picker
            ref="picker"
            opens="center"
            :locale-data="{ locale: daterange.local, format: 'yyyy-MM-dd' ,applyLabel:'确定',cancelLabel:'取消'}"
            :ranges="daterange.ranges"
            v-model="queryParam.criteria.daterange"
            style="min-width:200px;"
            placeholder="提交日期"
            class="m-1"
          ></date-range-picker>

          <b-button variant="outline-primary" @click="list()" class="m-1">查询</b-button>
          <!-- <json-excel :fields="excel.fields" :fetch="exportData" :name="excel.name" type="xls">
            <b-button variant="primary" class="m-2">导出</b-button>
          </json-excel>-->
        </b-form>
      </b-col>
      <b-col cols="2">
        <!-- <b-button variant="primary" @click="list()" class="mr-3 float-right">导入</b-button> -->
      </b-col>
    </b-row>

    <!-- 列表 -->
    <div style="min-height:430px;" class="mt-2">
      <b-table
        id="data-table"
        responsive
        hover
        :fields="fields"
        :items="items.data"
        :busy="tableLoading"
        :show-empty="true"
        primary-key="ID"
        empty-text="暂无数据"
        :no-local-sorting="true"
      >
        <template v-slot:table-busy>
          <div class="my-2 d-flex justify-content-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </template>

        <template v-slot:cell(fileSource)="data">
          <!-- <b-badge variant="success" class="mr-2">{{data.value}}</b-badge>
          <b-badge variant="info" v-if="data.item.fileFormat=='PDF'">PDF</b-badge>
          <b-badge variant="success" v-if="data.item.fileFormat=='OFD'">OFD</b-badge>
          <b-badge variant="warning" v-if="data.item.fileFormat!='OFD' && data.item.fileFormat!='PDF'">图片</b-badge> -->
          {{data.item.fileOriginalName}}
        </template>

        <template v-slot:cell(fileSubmitter)="data">
          <span v-if="data.item.fileSubmitterName != null && data.item.fileSubmitterName != data.item.fileSubmitter">{{data.item.fileSubmitterName}}&lt;{{data.item.fileSubmitter}}&gt;</span>
          <span v-if="data.item.fileSubmitterName != null && data.item.fileSubmitterName == data.item.fileSubmitter">{{data.item.fileSubmitterName}}</span>
          <span v-if="data.item.fileSubmitterName == null">{{data.item.fileSubmitter}}</span>
        </template>

        <template v-slot:cell(fileParseResult)="data">
          <span class="cursor" :id="data.item.id+'/parse'">
            <i :class="getIconClass(data.value)"></i>

            <b-tooltip
              delay="0"
              :target="data.item.id+'/parse'"
              :id="data.item.id+'/parse/tooltip'"
              :variant="getColorClass(data.value)"
              triggers="hover"
              placement="right"
            >{{data.item.fileParseMessage}}</b-tooltip>
          </span>
        </template>

        <template v-slot:cell(invVeriResult)="data">
          <span class="cursor" :id="data.item.id+'/veri'">
            <i :class="getIconClass(data.value)"></i>

            <b-tooltip
              delay="0"
              :target="data.item.id+'/veri'"
              :variant="getColorClass(data.value)"
              triggers="hover"
              placement="right"
            >{{data.item.invVeriMessage}}</b-tooltip>
          </span>
        </template>

        <template v-slot:cell(matchInvoice)="data">
          <span>
            <i v-if="data.value" class="fa fa-check-circle text-success"></i>
            <i v-if="!data.value" class="fa fa-times-circle text-danger"></i>
          </span>
        </template>

        <template v-slot:cell(invNo)="data">
          {{data.item.invCode}}-{{data.value}}
        </template>

        <template v-slot:cell(actions)="row">
          <b-link @click="handleView(row.item.id)" class="mr-2">查看</b-link>
          <b-link
            @click="handleMatchInvoice(row.item)"
            class="mr-2"
            v-if="!row.item.matchInvoice"
          >关联</b-link>
          <b-link
            @click="handleDelete(row.item.id)"
            class="mr-1"
            v-if="row.item.fileParseResult!='1'"
          >删除</b-link>
          <!-- <span v-if="row.item.handleStatus=='1'">无操作</span> -->
        </template>
      </b-table>
    </div>

    <!-- 分页 -->
    <div ref="paginationWrapper" class="mt-3">
      <div class="text-right float-left mx-2" style="height:30px;line-height:30px;"></div>
      <b-pagination
        class="float-right"
        @change="list"
        v-model="queryParam.page"
        :per-page="queryParam.size"
        :total-rows="items.totalElements"
        aria-controls="data-table"
        align="right"
      ></b-pagination>
      <div
        class="text-right float-right mx-2"
        style="height:30px;line-height:30px;"
      >共&nbsp;{{items.totalElements}}&nbsp;条</div>
    </div>

    <loading :show="pageLoading"></loading>

 
  </div>
</template>

<script>
import * as attachmentFacade from "../../../api/attachment-facade.js";
import * as orgFacade from "../../../api/org-facade.js";
import * as entFacade from "../../../api/ent-facade.js";

import { mapState } from "vuex";

import { zhCN } from "date-fns/locale";
import {
  addDays,
  addHours,
  startOfMonth,
  startOfYear,
  endOfMonth,
  addMonths,
  endOfYear,
  startOfWeek,
  endOfWeek,
  addWeeks
} from "date-fns/esm";

//import dayjs from "dayjs";

export default {
  // validations:
  data() {
    return {
      orgList: [
        { text: "机构", value: "" },
        { text: "机构一", value: "1" }
      ],
      fileSourceList: [
        { text: "文件来源", value: "" },
        { text: "邮件", value: "邮件" },
        { text: "录入", value: "录入" },
        { text: "API", value: "API" }
      ],
      invCheckResultList: [
        { text: "审核结果", value: "" },
        { text: "未通过", value: "0" },
        { text: "通过", value: "1" }
      ],
      invCataList: [
        { text: "增值税电子普通发票", value: "10" },
        { text: "增值税电子专用发票", value: "20" },
        { text: "增值税专用发票", value: "01" },
        { text: "增值税普通发票", value: "04" }
      ],

      daterange: {
        local: zhCN,
        locale: {
          localize: "zhCN",
          //汉化
          format: "YYYY-MM-DD", //设置显示格式
          applyLabel: "确定", //确定按钮文本
          cancelLabel: "取消", //取消按钮文本
          daysOfWeek: ["日", "一", "二", "三", "四", "五", "六"],
          monthNames: [
            "一月",
            "二月",
            "三月",
            "四月",
            "五月",
            "六月",
            "七月",
            "八月",
            "九月",
            "十月",
            "十一月",
            "十二月"
          ],
          firstDay: 1
        },
        dateFormat: "yyyy-MM-dd",
        ranges: {
          今天: [new Date(), new Date()],
          昨天: [addDays(new Date(), -1), addDays(new Date(), -1)],
          本月: [startOfMonth(new Date()), endOfMonth(new Date())],
          本年: [startOfYear(new Date()), endOfYear(new Date())],
          上一周: [
            addDays(startOfWeek(addWeeks(new Date(), -1)), 1),
            addDays(endOfWeek(addWeeks(new Date(), -1)), 1)
          ],
          上一月: [
            startOfMonth(addMonths(new Date(), -1)),
            endOfMonth(addMonths(new Date(), -1))
          ]
        }
      },

      fields: [
        {
          key: "orgName",
          label: "机构"
        },
        {
          key: "title",
          label: "类型"
        },
        {
          key: "fileSource",
          label: "文件",
          formatter: value => {
            return value;
          }
        },
        {
          key: "fileSubmitter",
          label: "提交人"
        },
        {
          key: "submitTime",
          label: "提交时间"
        },
        {
          key: "fileParseResult",
          label: "文件解析"
        },
        {
          key: "matchInvoice",
          label: "发票关联"
        },
        {
          key: "invNo",
          label: "发票号码"
        },
        {
          key: "totalAmount",
          label: "金额"
        },
        {
          key: "buyerName",
          label: "购方"
        },

        {
          key: "actions",
          label: "操作",
          thClass: "actions"
        }
      ],

      // 以下为数据展示和传输对象，基本上与后台接口的传输对象一致
      items: {
        totalElements: 0,
        data: []
      },
      queryParam: {
        size: 10,
        page: 1,
        criteria: {
          orgId: "",
          fileSource: "",
          invCheckResult: "",
          submitter: "",

          daterange: {
            startDate: addDays(new Date(), -90),
            endDate: new Date()
          },
          uploadDate: []
        },
        sortOrder: { createTime: "descending" }
      },
      //上传参数
      uploadParam: {
        file: ""
      },

      // 以上为数据展示和传输对象
      invoiceCheckDto:{},
      // 以下为页面状态控制参数
      showOrg: true,
      pageLoading: false,
      tableLoading: false, // 表格Loading状态

      opIndex: -1, // 当前操作的表格行索引
      // 以上为页面状态控制参数
      manualCheckDialogVisible:false,

      // 以下为表单校验规则

      // 以上为表单校验规则
    };
  },
  watch: {},
  computed: {
    ...mapState("admin/user", ["info"])
  },
  created() {
    this.initInfo();
  },
  mounted() {
    //
    // 异步加载列表数据
    this.handleQuery();
    // 异步加载检索条件中的“纳税人”下拉菜单
  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    // 异步加载列表数据
    list(page) {
      if (this.queryParam.criteria.daterange) {
        this.queryParam.criteria.uploadDate[0] = addHours(
          this.queryParam.criteria.daterange.startDate,
          8
        );
        this.queryParam.criteria.uploadDate[1] = addHours(
          this.queryParam.criteria.daterange.endDate,
          8
        );

        // this.queryParam.criteria.timeCreated[1] = new Date(
        //   this.queryParam.criteria.timeCreated[1] + " 59:59:59"
        // );
      }
      if (page) {
        this.queryParam.page = page;
      }
      this.tableLoading = true; // 打开表格的Loading状态
      attachmentFacade
        .pageList(this.queryParam) // 异步调用后台接口
        .then(res => {
          this.items = res; // 为表格填充数据
          this.tableLoading = false; // 关闭表格的Loading状态
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });
    },

    getIconClass(status) {
      switch (status) {
        case "0":
          return "fa fa-circle text-secondary";
        case "1":
          return "fa fa-check-circle text-success";
        case "2":
          return "fa fa-times-circle text-danger";
      }
    },
    //获取显示颜色
    getColorClass(status) {
      switch (status) {
        case "0":
          return "secondary";
        case "1":
          return "success";
        case "2":
          return "danger";
      }
    },
    //查看html
    handleView(id) {
      let fileUrl = process.env.VUE_APP_ATTACHMENT_DOWNLOAD_PREFIX + id;
      let viewerUrl = "./pdf/web/viewer.html?file=";

      window.open(viewerUrl + encodeURIComponent(fileUrl), "one");
    },
    //打开上传dialog窗口
    openUploadDialog() {
      // this.$refs["file-input"].reset();
      this.uploadParam.file = null;
      this.uploadDialogVisible = true;
    },
    // 执行查询操作
    handleQuery() {
      this.list();
    },
    //获取机构信息
    async getOrgInfo() {
      this.pageLoading = true;
      orgFacade
        .findByUserRole()
        .then(res => {
          this.pageLoading = false;
          let orgList = [{ text: "机构", value: "" }];
          if (res) {
            res.map(item => {
              let org = {};
              org.text = item.name;
              org.value = item.id;
              orgList.push(org);
            });
          }
          this.orgList = orgList;
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },
    //获取企业信息
    getEntInfo() {
      this.pageLoading = true;
      entFacade
        .findByUserRole()
        .then(res => {
          this.pageLoading = false;
          let entList = [{ text: "受票方", value: "" }];
          let ent = {};
          res.map(item => {
            ent.text = item.name;
            ent.value = item.id;
            entList.push(ent);
          });
          this.entList = entList;
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },
    //初始化信息
    initInfo() {
      let roles = this.info.roles;
      //系统管理员
      if (roles.indexOf("sys_admin") > -1) {
        this.showOrg = true;
        this.getOrgInfo();
      } else {
        //机构管理员或者财务经理
        this.showOrg = false;
        // 表格中不显示机构信息
        this.fields.splice(0,1);
      }
    },

    //
    showManualCheckDialog(value){
      let that = this;
      that.invoiceCheckDto = value
      this.manualCheckDialogVisible = true
    },

    // 删除
    handleDelete(val){
      this.$bvModal
        .msgBoxConfirm("确认删除该记录吗？", {
          title: "删除",
          size: "sm",
          buttonSize: "md",
          okVariant: "primary",
          okTitle: "确认",
          cancelTitle: "取消",
          footerClass: "p-2",
          hideHeaderClose: false
        })
        .then(value => {
          if (value) {
            // 执行删除操作
            this.pageLoading = true;
            attachmentFacade
              .deleterow(val)
              .then(() => {
                this.pageLoading = false;
                this.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.list();
              })
              .catch(err => {
                this.pageLoading = false;
                console.log("err", err);
              });

          }
        })
        .catch(err => {
          console.log(err);
        });      
    }
  }
};
</script>

<style >
.actions {
  width: 150px;
}
.vs__dropdown-toggle {
  height: 33.5px;
}
.cursor {
  cursor: pointer;
}
</style>
